export const CHAT_ATTACHMENT_MAX_SIZE_BYTES = 2 * 1024 * 1024;
export const CHAT_ATTACHMENT_MAX_SIZE_MB =
  CHAT_ATTACHMENT_MAX_SIZE_BYTES / (1024 * 1024);

export const CHAT_ATTACHMENT_ACCEPT = ".png,.jpg,.jpeg,.pdf,.docx,.xls,.xlsx";

const CHAT_ATTACHMENT_EXTENSIONS = new Set([
  ".png",
  ".jpg",
  ".jpeg",
  ".pdf",
  ".docx",
  ".xls",
  ".xlsx",
]);

const CHAT_ATTACHMENT_MIME_TYPES = new Set([
  "image/png",
  "image/jpeg",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
]);

export const CHAT_ATTACHMENT_RULES_LABEL = `Fichiers autorises : PNG, JPG, PDF, DOCX, XLS, XLSX (max. ${CHAT_ATTACHMENT_MAX_SIZE_MB} Mo)`;

const getFileExtension = (fileName: string) => {
  const extensionIndex = fileName.lastIndexOf(".");

  if (extensionIndex < 0) {
    return "";
  }

  return fileName.slice(extensionIndex).toLowerCase();
};

export const validateChatAttachment = (file: File) => {
  const fileExtension = getFileExtension(file.name);
  const mimeType = file.type.toLowerCase();

  if (!CHAT_ATTACHMENT_EXTENSIONS.has(fileExtension)) {
    return "Seuls les fichiers PNG, JPG, PDF, DOCX, XLS et XLSX sont autorises.";
  }

  if (
    mimeType &&
    mimeType !== "application/octet-stream" &&
    !CHAT_ATTACHMENT_MIME_TYPES.has(mimeType)
  ) {
    return "Seuls les fichiers PNG, JPG, PDF, DOCX, XLS et XLSX sont autorises.";
  }

  if (file.size > CHAT_ATTACHMENT_MAX_SIZE_BYTES) {
    return `La taille maximale autorisee pour une piece jointe est de ${CHAT_ATTACHMENT_MAX_SIZE_MB} Mo.`;
  }

  return null;
};
